module.exports = __webpack_public_path__ + "templates.product_review_entry-31ff002a.html";